export const CONTRIBUTE_STEPS = [
  "Basic information",
  "Workflow",
  "Audience and impact",
  "Additional resources",
  "Review and submit",
];
